import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import React, { forwardRef, useEffect, useState } from 'react';
import { getCountryCallingCode, getCountries, isValidPhoneNumber as validatePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import countriesList from './assets/countries.json';
import HandIcon from './assets/HandIcon';
import { TextInput as FlowBiteTextInput } from 'flowbite-react';
import { MenuSelector } from '../menu-selector';
/**
 * It is used to fetch the country flag
 *
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function getCountryFlagUrl(countryShort) {
  return "https://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(countryShort, ".svg");
}
/**
 *
 * It is used to create the countries data
 */

function getCountriesData() {
  var data = getCountries().map(function (country) {
    var countryShort = country;
    var countryName = countriesList[countryShort];
    return {
      countryName: countryName,
      countryShort: country,
      countryCode: getCountryCallingCode(country),
      flag: /*#__PURE__*/_jsx("img", {
        src: getCountryFlagUrl(countryShort),
        width: 20,
        height: 14,
        alt: country
      })
    };
  });
  return data;
}

export function isValidPhoneNumber(phoneNumber) {
  return validatePhoneNumber(phoneNumber);
}
export var countriesData = getCountriesData();
export var PhoneInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$defaultCountry = _ref.defaultCountry,
      defaultCountry = _ref$defaultCountry === void 0 ? 'IT' : _ref$defaultCountry,
      label = _ref.label,
      supportText = _ref.supportText,
      placeholder = _ref.placeholder,
      labelStyles = _ref.labelStyles,
      inputContainerStyles = _ref.inputContainerStyles,
      selectButtonStyles = _ref.selectButtonStyles,
      menuDialogStyles = _ref.menuDialogStyles,
      suffixIcon = _ref.suffixIcon,
      supportTextStyles = _ref.supportTextStyles,
      formatDisplayedNumber = _ref.formatDisplayedNumber,
      priorityCountries = _ref.priorityCountries,
      disabled = _ref.disabled,
      testIds = _ref.testIds,
      id = _ref.id,
      onBlur = _ref.onBlur;

  var _useState = useState(null),
      activeCountry = _useState[0],
      setActiveCountry = _useState[1];

  var _useState2 = useState(undefined),
      phoneNumber = _useState2[0],
      setPhoneNumber = _useState2[1];

  useEffect(function () {
    if (defaultCountry && activeCountry === null) {
      var selectedCountry = countriesData.find(function (country) {
        return country.countryShort.toString() === defaultCountry;
      });

      if (selectedCountry) {
        setActiveCountry(selectedCountry);
      }
    }
  }, [activeCountry, defaultCountry]); // Set phone number default value

  useEffect(function () {
    var parsedPhoneNumber = parsePhoneNumber(value || '', 'IT');

    if (parsedPhoneNumber && (!activeCountry || !phoneNumber)) {
      var countryCode = parsedPhoneNumber.country;
      var selectedCountry = countriesData.find(function (country) {
        return country.countryShort.toString() === countryCode;
      });

      if (selectedCountry) {
        setActiveCountry(selectedCountry);
      }

      var formattedValue = parsedPhoneNumber.nationalNumber.toString();
      var newValue = formatDisplayedNumber ? formatDisplayedNumber(formattedValue) : formatPhoneNumber(formattedValue);
      setPhoneNumber(newValue);
    }
  }, [activeCountry, formatDisplayedNumber, phoneNumber, value]);

  function onTextFieldChange(event) {
    var value = event.target.value;
    var formattedValue = getDigits(value);
    var newValue = formatDisplayedNumber ? formatDisplayedNumber(formattedValue) : formatPhoneNumber(formattedValue);
    setPhoneNumber(newValue);
    onChange("+".concat((activeCountry === null || activeCountry === void 0 ? void 0 : activeCountry.countryCode) || '').concat(formattedValue));
  }

  function onCountrySelectChange(countryShort) {
    var selectedCountry = countriesData.find(function (country) {
      return country.countryShort.toString() === countryShort;
    });

    if (selectedCountry) {
      setActiveCountry(selectedCountry);
      onChange("+".concat(selectedCountry.countryCode).concat(getDigits(phoneNumber || '')));
    }
  }

  function getActiveCountryLabel(activeCountry) {
    if (!activeCountry) {
      return;
    }

    return /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [activeCountry.flag, /*#__PURE__*/_jsxs("p", {
        children: ["+", "".concat(activeCountry.countryCode)]
      })]
    });
  }

  var countryOptions = countriesData.map(function (_ref2) {
    var countryName = _ref2.countryName,
        countryCode = _ref2.countryCode,
        countryShort = _ref2.countryShort,
        flag = _ref2.flag;
    return {
      label: /*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [' ', /*#__PURE__*/_jsx("div", {
          children: flag
        }), ' ', /*#__PURE__*/_jsxs("p", {
          children: [countryName, " (+", countryCode, ")"]
        }), ' ']
      }),
      value: countryShort
    };
  });

  function formatPhoneNumber(phoneNumber) {
    if (phoneNumber.length > 3) {
      return phoneNumber.slice(0, 3) + ' ' + phoneNumber.slice(3);
    }

    return phoneNumber;
  }

  function getDigits(value) {
    return value.replace(/\D/g, '');
  }

  var isErrored = variant === 'error';
  return /*#__PURE__*/_jsxs(_StyledDiv3, {
    children: [label && /*#__PURE__*/_jsx(StyledInputLabel, {
      labelStyles: labelStyles,
      children: label
    }), /*#__PURE__*/_jsxs(StyledInputContainer, {
      inputContainerStyles: inputContainerStyles,
      errored: isErrored,
      children: [/*#__PURE__*/_jsx(MenuSelector, {
        options: countryOptions,
        menuDialogStyles: generateMenuDialogStyles(menuDialogStyles),
        menuButtonStyles: generateMenuButtonStyles(isErrored, selectButtonStyles),
        onSelect: function onSelect(value) {
          return onCountrySelectChange(value.toString());
        },
        selectedLabel: getActiveCountryLabel(activeCountry),
        priorityItems: priorityCountries,
        disabled: disabled,
        testIds: {
          dropdownBtn: testIds === null || testIds === void 0 ? void 0 : testIds.dropdownBtn,
          dropdownOptions: testIds === null || testIds === void 0 ? void 0 : testIds.dropdownOptions
        }
      }), /*#__PURE__*/_jsx(_StyledDiv4, {
        children: /*#__PURE__*/_jsx(TextField, {
          variant: variant,
          onChange: onTextFieldChange,
          value: phoneNumber,
          placeholder: placeholder || '000 0000000',
          rightIcon: isErrored && HandIcon || suffixIcon && suffixIcon || undefined,
          disabled: disabled,
          "data-cy": (testIds === null || testIds === void 0 ? void 0 : testIds.input) || 'phone-number-input',
          id: id,
          onBlur: onBlur
        })
      })]
    }), (supportText || variant === 'error') && /*#__PURE__*/_jsx(StyledSupportText, {
      variant: variant,
      supportTextStyles: supportTextStyles,
      "data-cy": testIds === null || testIds === void 0 ? void 0 : testIds.supportText,
      children: supportText ? supportText : variant === 'error' ? 'Il numero di telefono non è valido' : ''
    })]
  });
});

var TextField = /*#__PURE__*/_styled(FlowBiteTextInput).withConfig({
  displayName: "formphone-input__TextField",
  componentId: "sc-gcih5w-0"
})(["", " input{", " ", " ", "}"], {
  "display": "flex",
  "flex": "1 1 0%",
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity)) !important"
}, {
  "borderRadius": "0px",
  "borderStyle": "none",
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity)) !important",
  "paddingLeft": "1rem",
  "paddingRight": "0.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  "outline": "2px solid transparent",
  "outlineOffset": "2px"
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'primary' ? {
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(156 163 175 / var(--tw-text-opacity))"
    }
  } : {};
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'error' ? {
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important",
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(186 0 31 / var(--tw-text-opacity))"
    }
  } : {};
});

var StyledInputLabel = /*#__PURE__*/_styled.p.withConfig({
  displayName: "formphone-input__StyledInputLabel",
  componentId: "sc-gcih5w-1"
})(function (_ref5) {
  var labelStyles = _ref5.labelStyles;
  return [{
    "marginBottom": "0.5rem",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  }].concat(_toConsumableArray(labelStyles || []));
});

var StyledInputContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "formphone-input__StyledInputContainer",
  componentId: "sc-gcih5w-2"
})(function (_ref6) {
  var errored = _ref6.errored,
      inputContainerStyles = _ref6.inputContainerStyles;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "gap": "0px",
    "borderRadius": "0.5rem",
    "borderTopWidth": "1px",
    "borderBottomWidth": "1px",
    "borderRightWidth": "1px",
    "borderStyle": "solid",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }].concat(_toConsumableArray(inputContainerStyles || []), [errored && {
    "--tw-border-opacity": "1 !important",
    "borderColor": "rgb(186 0 31 / var(--tw-border-opacity)) !important",
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important"
  }]);
});

var generateMenuDialogStyles = function generateMenuDialogStyles(menuDialogStyles) {
  return [{
    "maxHeight": "15.188rem",
    "width": "21.438rem !important",
    "overflow": "hidden",
    "overflowY": "scroll"
  }].concat(_toConsumableArray(menuDialogStyles || []));
};

var generateMenuButtonStyles = function generateMenuButtonStyles(errored, menuButtonStyles) {
  var styles = [{
    "borderTopLeftRadius": "0.5rem",
    "borderBottomLeftRadius": "0.5rem",
    "borderWidth": "0px",
    "borderRightWidth": "1px",
    "borderLeftWidth": "1px",
    "borderStyle": "solid",
    "--tw-border-opacity": "1",
    "borderLeftColor": "rgb(229 231 235 / var(--tw-border-opacity))",
    "borderRightColor": "rgb(229 231 235 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(249 250 251 / var(--tw-bg-opacity))"
  }].concat(_toConsumableArray(menuButtonStyles || []));

  if (errored) {
    styles.push({
      "--tw-border-opacity": "1 !important",
      "borderRightColor": "rgb(186 0 31 / var(--tw-border-opacity)) !important",
      "borderLeftColor": "rgb(186 0 31 / var(--tw-border-opacity)) !important",
      "--tw-bg-opacity": "1 !important",
      "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important"
    });
  }

  return styles;
};

var StyledSupportText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "formphone-input__StyledSupportText",
  componentId: "sc-gcih5w-3"
})(function (_ref7) {
  var variant = _ref7.variant,
      supportTextStyles = _ref7.supportTextStyles;
  return [{
    "marginTop": "0.75rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "fontWeight": "400"
  }, variant === 'primary' && {
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))"
  }].concat(_toConsumableArray(supportTextStyles || []), [variant === 'error' && {
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))"
  }]);
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formphone-input___StyledDiv",
  componentId: "sc-gcih5w-4"
})({
  "display": "inline-flex",
  "flexDirection": "row",
  "gap": "0.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formphone-input___StyledDiv2",
  componentId: "sc-gcih5w-5"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formphone-input___StyledDiv3",
  componentId: "sc-gcih5w-6"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formphone-input___StyledDiv4",
  componentId: "sc-gcih5w-7"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "paddingRight": "0.5rem"
});